import { markups } from "../../markups.js";
import { packPrice } from "./packs.js";
import { printPrice } from "./prints.js";

function totalMarkupsPercent(state) {
  return state.markups.reduce(
    (sum, idx) => sum + (markups[idx]?.percent ?? 0),
    0
  );
}

export function totalPrice(state) {
  const T = state.quantity || state.quantity_manual;
  const B = packPrice(state.handle, state.size, state.color);
  const N1 = state.face_colors;
  const N2 = state.rear_colors;

  if (!B || !T) return 0;

  const P = printPrice(state.size, T) ?? 0;
  const onePackPrint = P * (N1 + N2);
  const omega = T >= 500 ? (N1 + N2 - 1) * 1000 : 0;
  const price = T * (B + onePackPrint);
  const M = (100 + totalMarkupsPercent(state)) / 100;
  const withMarkups = Math.floor((price + price * (M - 1)) / 100) * 100;

  return withMarkups + omega;
}
